import React from "react";
import PropTypes from "prop-types";
import ScrollOverview from "../../scroll-overview/scroll-overview";

const ActsList = ({ nodes, participantTypeFilter }) => {

  return(
    <div className="list-wrapper">
      <ScrollOverview
        type={"participant"}
        participantTypeFilter={participantTypeFilter}
        nodes={nodes}
        tags={false}
        showBanners={false}
        updateUrl={false}
        displayType={"list"}
        clickBehavior={"link"}
      />
    </div>
  );
}

ActsList.propTypes = {
  nodes: PropTypes.array.isRequired
};

export default ActsList;
